import {
  Flex
} from "@chakra-ui/react";


import {
  AiOutlineBook, AiOutlineDownload, AiOutlineFileSearch, AiOutlineFileText, AiOutlineFolderOpen, AiOutlineHome, AiOutlineUser
} from "react-icons/ai";

import { BiSupport } from "react-icons/bi";
import { useUser } from "../../contexts/useUser";
import { userCanRead } from "../../services/AccessControl";
import { Path } from "../../types/accessControl";

import { SidebarMenuItem } from "./SidebarMenuItem";

export function Sidebar() {

  const { user } = useUser();
  if (!user) {
    return <></>
  }

  const AdminSubItems = [];
  if (userCanRead(user, Path.ACCOUNTS_MANANGER)) {
    AdminSubItems.push({ text: "Accounts", href: Path.ACCOUNTS_MANANGER });
  }
  if (userCanRead(user, Path.USERS_MANAGER)) {
    AdminSubItems.push({ text: "Users", href: Path.USERS_MANAGER });
  }
  if (userCanRead(user, Path.LICENSES_MANAGER)) {
    AdminSubItems.push({ text: "Licenses", href: Path.LICENSES_MANAGER });
  }
  if (userCanRead(user, Path.PRODUCTS_MANAGER)) {
    AdminSubItems.push({ text: "Products", href: Path.PRODUCTS_MANAGER });
  }
  if (userCanRead(user, Path.RESOURCES_MANAGER)) {
    AdminSubItems.push({ text: "Resources", href: Path.RESOURCES_MANAGER });
  }
  if (userCanRead(user, Path.DOCUMENTATIONS_MANAGER)) {
    AdminSubItems.push({ text: "Documentation", href: Path.DOCUMENTATIONS_MANAGER });
  }

  const DownloadSubItems = [];
  if (userCanRead(user, Path.DOWNLOADS_HELYX)) {
    DownloadSubItems.push({ text: "HELYX", href: Path.DOWNLOADS_HELYX });
  }
  if (userCanRead(user, Path.DOWNLOADS_ELEMENTS)) {
    DownloadSubItems.push({ text: "ELEMENTS", href: Path.DOWNLOADS_ELEMENTS });
  }

  const DocumentationSubItems = [];
  if (userCanRead(user, Path.DOCUMENTATIONS_HELYX)) {
    DocumentationSubItems.push({ text: "HELYX", href: Path.DOCUMENTATIONS_HELYX });
  }
  if (userCanRead(user, Path.DOCUMENTATIONS_ELEMENTS)) {
    DocumentationSubItems.push({ text: "ELEMENTS", href: Path.DOCUMENTATIONS_ELEMENTS });
  }

  const SupportSubItems = [];
  if (userCanRead(user, Path.SUPPORT_HELYX)) {
    SupportSubItems.push({ text: "HELYX", href: Path.SUPPORT_HELYX });
  }
  if (userCanRead(user, Path.SUPPORT_ELEMENTS)) {
    SupportSubItems.push({ text: "ELEMENTS", href: Path.SUPPORT_ELEMENTS });
  }

  return (
    <Flex
      flexDirection="column"
      gap="5px"
      height="100%"
      background="gray.400"
      fontFamily="var(--chakra-fonts-body)"
      fontSize="16px"
      sx={{
        p: {
          base: '5px',
          sm: '20px',
          md: '30px'
        },
        minWidth: {
          base: '230px',
          sm: '260px',
          md: '280px',
        }
      }}
    >
      <SidebarMenuItem href="/" text="Dashboard" icon={AiOutlineHome} />
      {AdminSubItems.length > 0 &&
        <SidebarMenuItem
          text="Admin"
          href="/admin"
          icon={AiOutlineUser}
          links={AdminSubItems}
        />
      }
      {userCanRead(user, Path.LICENSES) &&
        <SidebarMenuItem href={Path.LICENSES} text="Licenses" icon={AiOutlineFileSearch} />
      }
      {DownloadSubItems.length > 0 &&
        <SidebarMenuItem
          text="Downloads"
          href="/downloads"
          icon={AiOutlineDownload}
          links={DownloadSubItems}
        />
      }
      {DocumentationSubItems.length > 0 &&
        <SidebarMenuItem
          text="Documentation"
          icon={AiOutlineFileText}
          href="/documentations"
          links={DocumentationSubItems}
        />
      }
      {userCanRead(user, Path.RESOURCES) &&
        <SidebarMenuItem href={Path.RESOURCES} text="Resources" icon={AiOutlineBook} />
      }
      {SupportSubItems.length > 0 &&
        <SidebarMenuItem
          text="Support"
          href="/support"
          icon={BiSupport}
          links={SupportSubItems}
        />
      }
      {userCanRead(user, Path.FILE_MANAGER) &&
        <SidebarMenuItem href={Path.FILE_MANAGER} text="File Manager" icon={AiOutlineFolderOpen} />
      }
      {userCanRead(user, Path.FAKE_DATA) &&
        <SidebarMenuItem href={Path.FAKE_DATA} text="Fake Data" icon={AiOutlineFolderOpen} />
      }
    </Flex>
  );
}
